export interface ReaderServerSelection {
  readonly configuredServer?: string;
  readonly serverParameter?: string | null;
  readonly loopbackApplication: boolean;
}

export function selectReaderServerUrl(input: ReaderServerSelection): string {
  if (input.loopbackApplication && input.serverParameter) {
    return new URL(input.serverParameter).origin;
  }
  if (input.configuredServer) {
    return new URL(input.configuredServer).origin;
  }
  if (input.loopbackApplication) {
    return "http://127.0.0.1:8787";
  }
  throw new Error("Reader deployment has no explicit mdbase Connect authority.");
}
